import script from "./CaseContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseContent.vue?vue&type=script&setup=true&lang=js"

import "./CaseContent.vue?vue&type=style&index=0&id=9a2ae4b4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2ae4b4"]])

export default __exports__